var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c(
        "div",
        { staticClass: "layout_nav" },
        [_c("Nav", _vm._b({}, "Nav", _vm.getRol, false))],
        1
      ),
      _c(
        "div",
        { staticClass: "layout_center" },
        [
          _c("div", { staticClass: "layout_row" }, [
            _c(
              "div",
              { staticClass: "layout_colum" },
              [_c("Welcome", _vm._b({}, "Welcome", _vm.getUser, false))],
              1
            ),
            _c(
              "div",
              { staticClass: "layout_colum" },
              [
                _c("Snackbar", {
                  attrs: {
                    visible: _vm.getAlert.snackbar,
                    text: _vm.getAlert.text,
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "v-row",
            { staticClass: "report_cards_ctn" },
            [
              _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                _c("div", { staticClass: "card_report" }, [
                  _c("div", { staticClass: "card_report_title" }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", { attrs: { "aria-hidden": "false" } }, [
                          _vm._v("mdi-file-chart"),
                        ]),
                        _vm._v(" LECTURAS "),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "card_report_body" }, [
                    _c("p", [
                      _vm._v(
                        " Generar un reporte de lecturas de todos los dispositivos por periodo. "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card_report_footer" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.reportReads()
                            },
                          },
                        },
                        [_c("span", [_vm._v(" Generar ")])]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                _c("div", { staticClass: "card_report" }, [
                  _c("div", { staticClass: "card_report_title" }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", { attrs: { "aria-hidden": "false" } }, [
                          _vm._v("mdi-file-chart"),
                        ]),
                        _vm._v(" LECTURAS DE DISPOSITIVO "),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "card_report_body" }, [
                    _c("p", [
                      _vm._v(
                        " Generar un reporte de lecturas de un dispositivo en especifico. "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card_report_footer" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.reportDevice()
                            },
                          },
                        },
                        [_c("span", [_vm._v(" Generar ")])]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                _c("div", { staticClass: "card_report" }, [
                  _c("div", { staticClass: "card_report_title" }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", { attrs: { "aria-hidden": "false" } }, [
                          _vm._v("mdi-file-chart"),
                        ]),
                        _vm._v(" DISPOSITIVOS POR CLIENTE "),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "card_report_body" }, [
                    _c("p", [
                      _vm._v(
                        "Generar un reporte de todos los dispositivos del cliente."
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card_report_footer" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.reportClient()
                            },
                          },
                        },
                        [_vm._v(" Generar ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                _c("div", { staticClass: "card_report" }, [
                  _c("div", { staticClass: "card_report_title" }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", { attrs: { "aria-hidden": "false" } }, [
                          _vm._v("mdi-file-chart"),
                        ]),
                        _vm._v(" HISTORIAL DE DISPOSITIVO "),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "card_report_body" }, [
                    _c("p", [
                      _vm._v(
                        " Generar un reporte del historial de datos de un dispositivo. "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card_report_footer" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.reportInvoice()
                            },
                          },
                        },
                        [_c("span", [_vm._v(" Generar ")])]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                _c("div", { staticClass: "card_report" }, [
                  _c("div", { staticClass: "card_report_title" }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", { attrs: { "aria-hidden": "false" } }, [
                          _vm._v("mdi-file-chart"),
                        ]),
                        _vm._v(" NOTIFICACIONES DE DISPOSITIVOS "),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "card_report_body" }, [
                    _c("p", [
                      _vm._v(
                        " Generar un reporte de las notificaciones generadas por los dispositivos. "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card_report_footer" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.reportDevicesNotifications()
                            },
                          },
                        },
                        [_c("span", [_vm._v(" Generar ")])]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                _c("div", { staticClass: "card_report" }, [
                  _c("div", { staticClass: "card_report_title" }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", { attrs: { "aria-hidden": "false" } }, [
                          _vm._v("mdi-file-chart"),
                        ]),
                        _vm._v(" INTEGRADORES POR CLIENTE "),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "card_report_body" }, [
                    _c("p", [
                      _vm._v(
                        "Genera un reporte de Integradores disponibles del cliente."
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card_report_footer" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.reportIntegrator()
                            },
                          },
                        },
                        [_c("span", [_vm._v(" Generar ")])]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                _c("div", { staticClass: "card_report" }, [
                  _c("div", { staticClass: "card_report_title" }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", { attrs: { "aria-hidden": "false" } }, [
                          _vm._v("mdi-file-chart"),
                        ]),
                        _vm._v(" DATOS DEL INTEGRADOR "),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "card_report_body" }, [
                    _c("p", [
                      _vm._v(
                        " Generar un reporte de los datos de un integrador especifico. "
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "card_report_footer" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.reportIntegratorRange()
                            },
                          },
                        },
                        [_c("span", [_vm._v(" Generar ")])]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("ReadsReport", {
        attrs: { visible: _vm.readsFlag },
        on: {
          close: function ($event) {
            _vm.readsFlag = false
          },
        },
      }),
      _c("ClientReport", {
        attrs: { visible: _vm.clientFlag },
        on: {
          close: function ($event) {
            _vm.clientFlag = false
          },
        },
      }),
      _c("DeviceReport", {
        attrs: { visible: _vm.deviceFlag },
        on: {
          close: function ($event) {
            _vm.deviceFlag = false
          },
        },
      }),
      _c("InvoiceReport", {
        attrs: { visible: _vm.invoiceFlag },
        on: {
          close: function ($event) {
            _vm.invoiceFlag = false
          },
        },
      }),
      _c("IntegratorReport", {
        attrs: { visible: _vm.integratorFlag },
        on: {
          close: function ($event) {
            _vm.integratorFlag = false
          },
        },
      }),
      _c("IntegratorReportRange", {
        attrs: { visible: _vm.integratorRangeFlag },
        on: {
          close: function ($event) {
            _vm.integratorRangeFlag = false
          },
        },
      }),
      _c("DevicesNotifications", {
        attrs: { visible: _vm.devicesNotifications },
        on: {
          close: function ($event) {
            _vm.devicesNotifications = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }